import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { Badge, Breadcrumb, Calendar, Flex, Row, Space } from "antd";
import { Button, CardContainer } from "components/elements";
import EmployeeList from "./EmployeeList";

import styles from "../styles/MyTeamCalendar.module.css";
import EmployeeWorkInCalendar from "features/employee/pages/EmployeeWorkInCalendar";
import { useState } from "react";
// import EmployeeWorkInCalendar from "features/employee/components/EmployeeWorkInCalendar";


function MyTeamCalendar({
  getWorkInCalendar = () => { },
  employeeMenu = () => { },
  pagination = {},
  isLoading = false,
  total = 0,
  setPagination = () => { },
  setTotal = () => { },
  getAllEmployee = () => { }
}) {
  const { t } = useTranslation();
  const [employeeTeam, setEmployeeTeam] = useState(null);
  const [employeeName, setEmployeeName] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Flex vertical>
        <Breadcrumb items={[
          { title: t("home.header"), href: "/" },
          { title: t("my_team.header"), href: "" },
          { title: t("workin_calendar.header") },
        ]} />
        <h2>{t("workin_calendar.header")}</h2>
      </Flex>

      <Flex gap={6} style={{ width: "100%" }}>
        <EmployeeList
          pagination={pagination}
          setPagination={setPagination}
          total={total}
          isLoading={isLoading}
          setTotal={setTotal}
          employeeList={employeeMenu}
          setEmployeeTeam={setEmployeeTeam}
          setEmployeeName={setEmployeeName}
          getWorkInCalendar={getWorkInCalendar}
          getAllEmployee={getAllEmployee}
        />

        {/* <Flex vertical gap={24} style={{ width: "100%" }}> */}
        <div style={{
          width: '100%',
          maxWidth: '100vw',
          overflow: 'hidden',
          padding: isMobile ? '12px' : '24px',
          boxSizing: 'border-box',
        }}>
          <EmployeeWorkInCalendar
            employeeTeam={employeeTeam}
            employeeName={employeeName}
          />
        </div>
        {/* </Flex> */}
      </Flex>
    </Space>
  );
}

export default MyTeamCalendar;
